import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PriceFilteringAction } from '../priceFiltering.action';

type IDependencies = IClientApiDependencySegment;

export const removePriceFilteringProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PriceFilteringAction.remove.started),
  mergeMap((params) => {
    return dependencies.api.deletePriceFilteringProfile({ id: params.priceFilteringId }).pipe(
      mergeMap(() => {
        return [
          PriceFilteringAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          PriceFilteringAction.remove.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
